import {Color} from '@tiptap/extension-color';
import {FontFamily} from '@tiptap/extension-font-family';
import {Highlight} from '@tiptap/extension-highlight';
import {Link} from '@tiptap/extension-link';
import {ListItem} from '@tiptap/extension-list-item';
import {Subscript} from '@tiptap/extension-subscript';
import {Superscript} from '@tiptap/extension-superscript';
import {TextAlign} from '@tiptap/extension-text-align';
import {TextStyle} from '@tiptap/extension-text-style';
import {Typography} from '@tiptap/extension-typography';
import {Underline} from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import {FontSize} from '../tiptap-extension/FontSize';
import {LineHeight} from '../tiptap-extension/LineHeight';

export const textExtensions = [
    Color.configure({types: [TextStyle.name, ListItem.name]}),
    TextAlign.configure({
        types: ['heading', 'paragraph'],
    }),
    FontFamily.configure({
        types: ['textStyle'],
    }),
    Highlight,
    Underline,
    LineHeight,
    Typography,
    Superscript,
    Subscript,
    FontSize,
    TextStyle.configure(),
    StarterKit.configure({
        bulletList: {
            keepMarks: true,
            keepAttributes: false,
        },
        orderedList: {
            keepMarks: true,
            keepAttributes: false,
        },
    }),
    Link.configure({
        openOnClick: false,
        autolink: true,
        HTMLAttributes: {target: '_blank'},
        defaultProtocol: 'https',
        protocols: ['http', 'https', 'ftp', 'mailto'],
    }),
];
